import Vue from "vue";
import axios from "axios/index";
import VueAxios from "vue-axios";

Vue.use(VueAxios, axios);

const axiosConf = axios.create({
  baseURL: window.location.origin + "/",
  // baseURL: "https://bk.cashsystemes.com/",
  timeout: 6000000,
  headers: {
    "X-Client-Csi": "true",
    "Access-Control-Allow-Origin": "*",
  },
});

Vue.prototype.$axios = axiosConf;

export default axiosConf;
